var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3398_5115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5572 7.88908e-08C14.096 7.88908e-08 10.7126 1.02636 7.83471 2.94928C4.95685 4.87221 2.71383 7.60533 1.3893 10.803C0.0647648 14.0007 -0.281794 17.5194 0.393448 20.9141C1.06869 24.3088 2.7354 27.4269 5.18282 29.8744C7.63024 32.3218 10.7484 33.9885 14.1431 34.6637C17.5378 35.339 21.0564 34.9924 24.2541 33.6679C27.4519 32.3434 30.185 30.1003 32.1079 27.2225C34.0308 24.3446 35.0572 20.9612 35.0572 17.5C35.0574 15.2018 34.6049 12.9261 33.7255 10.8028C32.8461 8.67949 31.5571 6.75021 29.932 5.12514C28.307 3.50008 26.3777 2.21104 24.2544 1.33166C22.1311 0.452284 19.8554 -0.000218142 17.5572 7.88908e-08ZM19.7171 19.8244V28.1632H15.4139V19.8244C10.5775 19.6001 6.94056 18.6431 6.94056 17.4983C6.94056 16.3536 10.5791 15.3916 15.4139 15.1723V12.5655H9.45931V8.59798H25.67V12.5655H19.7171V15.169C24.5469 15.3916 28.1788 16.3503 28.1788 17.495C28.1788 18.6398 24.5469 19.6051 19.7171 19.8244Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7187 15.4697V18.3773C19.5958 18.3889 18.9295 18.4438 17.602 18.4438C16.4972 18.4438 15.6964 18.3972 15.4156 18.3773V15.4697C11.1407 15.6591 7.94905 16.4034 7.94905 17.2973C7.94905 18.1911 11.1407 18.9321 15.4156 19.1248C15.6914 19.1398 16.4723 19.1715 17.5755 19.1715C18.9644 19.1715 19.5891 19.1333 19.7104 19.1266C23.9753 18.9356 27.1603 18.1911 27.1603 17.2989C27.1603 16.4067 23.982 15.6608 19.7187 15.4697Z",
    fill: "#E1E1E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3398_5115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.0571823)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.a56c6d1edd6beaad5c0d0d1aa910233f.svg";
export { ForwardRef as ReactComponent };